
































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import { MemberConsumeApi } from "@/common/api/financeManage/allMemberConsumeRecord";

import { excuteDownloadExport2Excel } from "@/common/xlsx";
export const pageApiList = getPageAPIs(MemberConsumeApi);

import { transferUserLevel2ch } from "@/common/config";

const defaultForm = {
  mobile: "", // 手机号

  create_time: [], // 消费时间
};

const defaultForms = {
  phone: "", // 手机号
  price: "", // 扣款金额
  remark: "", // 备注
};

const transfromGenders: any = ["", "女", "男"];

@Component({
  filters: {
    showUserMemberTypeName: function (type: number) {
      return transferUserLevel2ch[type] || "";
    },
  },
})
export default class MemberConsumeList extends Vue {
  private memberConsumeApi: any;

  private deepLoopUtil: any;

  constructor() {
    super();
    this.memberConsumeApi = new MemberConsumeApi();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };

    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms),
    };
  }

  private form: any;

  private forms: any;

  private firstLoading: boolean = true;
  // private chooseTechnicianItem : any = null;

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private activated(): void {
    this.getTable();
  }

  private getTable(): void {
    this.memberConsumeApi.getMemberConsumeRecordList(
      this.getMemberConsumeRecordListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      },
      false
    );
  }

  private getMemberConsumeRecordListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      mobile,
      create_time, // 消费时间
      // finish_time, // 完成时间
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {};
    if (mobile) {
      outerParams.mobile = mobile;
    }

    if (Array.isArray(create_time) && create_time.length === 2) {
      const [startDate, endDate] = create_time;

      const startTime = Util.dateTimeUtilnohms(startDate);
      const endTime = Util.dateTimeUtilnohms(endDate);

      outerParams.start_date = startTime;

      outerParams.end_date = endTime;
    }

    if (
      mode == "exportExcel" &&
      !(outerParams.start_date && outerParams.end_date)
    ) {
      this.$message.error("请选择日期导出数据");
      return null;
    }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  private dialogFormVisible: boolean = false;

  private sumbitCustomMemberConsumeLoading: boolean = false;
  // // 唤起会员扣款弹框
  private handleWakeCustomMemberConsumeDialog() {
    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms),
    };

    this.dialogFormVisible = true;
  }

  // 扣款金额限制
  private handleLimitConsumePrice(val: string) {
    Util.limitDigitalnput(
      val,
      (new_val: string) => {
        this.$set(this.forms, "price", new_val);
      },
      (new_val: string) => {
        this.$set(this.forms, "price", new_val);
      },
      2
    );
  }

  // // 提交修改
  private handleSumbitCustomMemberConsume() {
    const { phone, price, remark } = this.forms || {};

    // if (!phone) {
    //   this.$message.error('请输入手机号')
    //   return
    // }

    if (!price) {
      this.$message.error("请输入扣款金额");
      return;
    }

    // if (!remark) {
    //   this.$message.error('请输入比赛名称')
    //   return
    // }

    this.sumbitCustomMemberConsumeLoading = true;

    this.memberConsumeApi.customDecreaseMemberConsume(
      {
        phone,
        price,
        remark,
      },
      () => {
        this.$message.success("扣款成功");

        this.sumbitCustomMemberConsumeLoading = false;
        this.dialogFormVisible = false;

        this.getTable();
      },
      () => {
        this.sumbitCustomMemberConsumeLoading = false;
      }
    );
  }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const { gender } = data;
    const newData = {
      ...data,
      // device_name: orderDeviceType2ch[device],
      // pay_type_name: payType2ch[pay_type],
      // user_level_type_name: userLevel2ch[user_type],
      gender_sex: transfromGenders[gender],
    };

    return newData;
  }

  /** 导出excel */
  private downloadExcelLoading: boolean = false;

  // 订单字段名 文案对应关系
  private orderExcelList2ch: any = {
    phone: "手机号",
    memberTypeName: "会员等级",
    price: "扣款金额",
    created_at: "扣款时间",
    remark: "扣款原因",
    opt_name: "操作人",
    opt_time: "操作时间",
  };
  // 订单Excel 表头的先后顺序
  private orderExcelSortList: string[] = [
    "phone",
    "memberTypeName",
    "price",
    "created_at",
    "remark",
    "opt_name",
    "opt_time",
  ];

  // 点击导出excel 表格
  private handleDownloadExcel() {
    const params = this.getMemberConsumeRecordListParams("exportExcel");

    if (params === null) {
      return false;
    }

    this.downloadExcelLoading = true;
    this.memberConsumeApi.exportExcelMemberConsumeList(
      params,
      (res: any) => {
        const {
          start_date,
          end_date,
          // over_start_time,
          // over_end_time,
        } = params || {};

        const create_time_duration_name =
          start_date && end_date ? `时间${start_date}到${end_date}` : "";

        // const finish_time_duration_name =
        //   over_start_time && over_end_time
        //     ? `完成时间${over_start_time}到${over_end_time}`
        //     : "";
        const filename = `会员扣款记录列表 ${create_time_duration_name}.xlsx`;
        const { data } = res || {};

        const { list: originList } = data || {};

        const newList = Array.isArray(originList)
          ? originList.map((item) => {
              const { type } = item || {};

              const newItem = {
                ...(item || {}),

                memberTypeName: transferUserLevel2ch[type],
              };

              return newItem;
            })
          : [];

        if (newList.length > 0) {
          const orderExcelSortList = this.orderExcelSortList;

          const orderExcelList2ch = this.orderExcelList2ch;

          const excelJSONData = getExcelJSONDataByList(
            newList,
            orderExcelSortList,
            orderExcelList2ch
          );

          excuteDownloadExport2Excel(excelJSONData, filename);
        } else {
          this.$message.info("选中时段没有可导出的信息");
        }

        this.downloadExcelLoading = false;
      },
      () => {
        this.downloadExcelLoading = false;
      }
    );
  }

  /** end 导出excel */

  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
